import React from 'react';
import BotoneraOrganizadoresInt from './BotoneraOrganizadoresInt.js';
import PanelHeaderColapsable from '../UI/PanelHeaderColapsable.js';
import styles from './CuadroTiposTorneoOrganizadores.module.css';

const CuadroTiposTorneoOrganizadores = (props) => {
  const organizadores = props.organizadores;
  const titulo = props.titulo;

  return (
    <div className={`${styles.cuadro}`}>
      <PanelHeaderColapsable
        titulo={titulo || 'Torneos por organizador'}
        colapsableEnMobile={true}
        breakpoint={1024}
        expandidoInicial={false}
        ariaLabelToggle="Expandir o contraer torneos por organizador"
      >
        <div className={`${styles.botoneraOrganizadores}`}>
          <BotoneraOrganizadoresInt organizadores={organizadores} />
        </div>
      </PanelHeaderColapsable>
    </div>
  );
};

export default CuadroTiposTorneoOrganizadores;
